import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("aarogya_admin_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Convert any backend error (string, {detail:string}, {detail:[{msg}]}, etc.) into a UI-safe string
export const errMsg = (err, fallback = "Something went wrong") => {
  const d = err?.response?.data?.detail ?? err?.response?.data ?? err?.message;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x === "string" ? x : x?.msg || JSON.stringify(x))).join(", ");
  if (typeof d === "object") return d.msg || JSON.stringify(d);
  return fallback;
};
